/**
 * Shared types: one per table, plus every API request and response body.
 *
 * Row types are inferred from the Drizzle models so they cannot drift from the
 * database. Wire types are declared explicitly, because what a browser is
 * allowed to see is a security decision and not a projection of a table.
 */
/* -------------------------------------------------------------------------- */
/* Errors                                                                     */
/* -------------------------------------------------------------------------- */
/**
 * The only error codes the API returns. Messages are deliberately dull: they
 * must never reveal whether an address, customer or document exists.
 */
export const API_ERROR_CODE = {
    BAD_REQUEST: 'bad_request',
    UNAUTHENTICATED: 'unauthenticated',
    FORBIDDEN: 'forbidden',
    NDA_REQUIRED: 'nda_required',
    NOT_FOUND: 'not_found',
    RATE_LIMITED: 'rate_limited',
    TURNSTILE_FAILED: 'turnstile_failed',
    INTERNAL: 'internal',
};
//# sourceMappingURL=types.js.map